const MANAGE_SUBORDINATES = 'MANAGE_SUBORDINATES';

export const checkIsManager = (userAuth: any): boolean => {
  const { permissions: { ALLOW = [], OVERRIDE = [] } = {} } = userAuth;

  return [...ALLOW, ...OVERRIDE]?.includes(MANAGE_SUBORDINATES);
};

const isManagerCommandCenterEnabledGlobally = (company: any): boolean => {
  const { managerCommandCenterEnabled = false } = company?.companySettings || {};
  return managerCommandCenterEnabled;
};

const isManagerCommandCenterEnabledForUser = (userId: any, tempFeatureConfig: any): boolean => {
  const { SelectiveManagerCommandCenterEnabled = false, SelectiveManagerCommandCenterList = [] } =
    tempFeatureConfig || {};
  return (
    SelectiveManagerCommandCenterEnabled &&
    SelectiveManagerCommandCenterList?.length > 0 &&
    SelectiveManagerCommandCenterList.indexOf(userId) > -1
  );
};

export const checkManagerCommandCenterEnabled = (userAuth: any): boolean => {
  const { company, tempFeatureConfig, id: userId } = userAuth;
  return !!(
    isManagerCommandCenterEnabledGlobally(company) ||
    isManagerCommandCenterEnabledForUser(userId, tempFeatureConfig)
  );
};

export const checkMCCAsHomepageEnabled = (userAuth: any): boolean =>
  userAuth.tempFeatureConfig?.showManagerCommandCenterAsHomepage === true;
